import { LanguageISO } from 'utils/localisation'

type CompanyDocumentTemplateGroup = 'booking_authorization' | 'import' | 'export'
type CompanyDocumentTemplateLanguage = LanguageISO
type CompanyDocumentTemplateLabel =
  | 'booking_authorization'
  | 'customs_clearance'
  | 'fiscal_customs'
  | 'self_declaration_customs'
  | 'export_declaration'

export const CompanyDocumentTemplateGroupMap: Record<CompanyDocumentTemplateGroup, string> = {
  booking_authorization: 'Booking Authorization',
  import: 'Import',
  export: 'Export',
}

export const CompanyDocumentTemplateLabelMap: Record<CompanyDocumentTemplateLabel, string> = {
  booking_authorization: 'Booking Authorization',
  customs_clearance: 'Customs Clearance',
  fiscal_customs: 'Fiscal Customs',
  self_declaration_customs: 'Self Declaration Customs',
  export_declaration: 'Export Declaration',
}

type CompanyDocumentTemplateTemplateFileResponse = {
  language: CompanyDocumentTemplateLanguage
  bucket: string
  s3FileName: string
  fileName: string
  fields: string[]
  legacyCode?: string
}

export type CompanyDocumentTemplateTemplateFile = Partial<CompanyDocumentTemplateTemplateFileResponse> & {
  file: File
}

export type CompanyDocumentTemplate = {
  id: string
  createdAt?: Date
  updatedAt?: Date
  createdBy?: string
  updatedBy?: string
  code: string
  displayName: string
  group: string
  label: CompanyDocumentTemplateLabel
  sequenceNumber: number
  files: CompanyDocumentTemplateTemplateFile[]
  documentTypeCode: string
}
